import { render, staticRenderFns } from "./TrackingPedido.vue?vue&type=template&id=143b4091&"
import script from "./TrackingPedido.vue?vue&type=script&lang=js&"
export * from "./TrackingPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports